import { formatXeroPaymentSentDisplay } from "@shared/markPaidXeroWorkflow";
import { cn } from "@/lib/utils";

/** Completed Xero payment transmission status (date / time / actor). */
export function XeroPaymentSentStatus(props: {
  syncedAt?: Date | string | null;
  sentBy?: string | null;
  className?: string;
  compact?: boolean;
}) {
  const display = formatXeroPaymentSentDisplay({
    syncedAt: props.syncedAt,
    sentBy: props.sentBy,
  });
  return (
    <div
      className={cn(
        "text-emerald-800 border border-emerald-200 bg-emerald-50 rounded-md",
        props.compact ? "text-xs px-2 py-1" : "text-sm py-2 px-3",
        props.className,
      )}
    >
      <p className={cn("font-medium", props.compact ? "" : "text-center")}>{display.title}</p>
      {display.dateLine ? (
        <p className={cn("text-emerald-700", props.compact ? "mt-0.5" : "mt-1 text-center")}>
          {display.dateLine}
        </p>
      ) : null}
      {display.timeLine ? (
        <p className={cn("text-emerald-700", props.compact ? "" : "text-center")}>{display.timeLine}</p>
      ) : null}
      {display.byLine ? (
        <p className={cn("text-emerald-700", props.compact ? "" : "text-center")}>{display.byLine}</p>
      ) : null}
    </div>
  );
}
